// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage__error--12s"};